import { IOption } from '@cian/ui-kit';

import { ECompanyType } from '../../../../../repositories/coworking/v1/apply-for-publication';

export const companyTypeSelectOptions: Array<IOption<ECompanyType>> = [
  { label: 'Брокер', value: ECompanyType.Broker },
  { label: 'Собственник бизнес-центра', value: ECompanyType.BusinessCenterOwner },
  { label: 'Управляющая компания', value: ECompanyType.ManagementCompany },
  { label: 'Оператор коворкинга', value: ECompanyType.Operator },
];
